import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "antd";
import PageWithSidebar from "./Container/IndexPage";
import NewsList from "./Container/NewsList";
import LandingPage from "./Container/Landing";
import NewsGen from "./Container/NewsGen";
import { ArticleGen } from "./Container/ArticleGen";
import { Announcement } from "./Container/Announcement";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./Keycloak";
import PrivateRoute from "./PrivateRoute";
import RoleBasedRoute from "./RoleBasedRoute";
import NoPermission from "./NoPermission";
import LoginLoader from "./Components/Loader/LoginLoader";
import UserProfile from "./Components/UserProfile";
import TermsOfService from "./Container/Landing/components/Policies/Terms";
import RefundPolicy from "./Container/Landing/components/Policies/Refund";
import PrivacyPolicy from "./Container/Landing/components/Policies/Privacy";
import ReportNews from "./Container/ReportNews";
import FloatingReportButton from "./Components/FloatingReportButton";

const { Content } = Layout;

const App = () => {
  return (
    <Content
      id="Main"
      style={{
        overflowX: "hidden",
        overflowY: "hidden",
        background: "whitesmoke",
        height: "100%",
      }}
    >
      <ReactKeycloakProvider
        authClient={keycloak}
        LoadingComponent={<LoginLoader />}
      >
        <Routes>
          <Route element={<PageWithSidebar />}>
            <Route index element={<LandingPage />} />
            <Route path="LandingPage" element={<LandingPage />} />
            <Route path="terms-of-service" element={<TermsOfService />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="NewsList" element={<PrivateRoute><NewsList /></PrivateRoute>} />
            <Route path="News" element={<PrivateRoute><NewsGen /></PrivateRoute>} />
            <Route path="Article" element={<PrivateRoute><ArticleGen /></PrivateRoute>} />
            <Route path="Announcement" element={<PrivateRoute><Announcement /></PrivateRoute>} />
            <Route path="UserProfile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
            <Route
              path="report-news"
              element={
                <RoleBasedRoute requiredRole="reporter">
                  <ReportNews />
                </RoleBasedRoute>
              }
            />
          </Route>
        </Routes>
        <FloatingReportButton />
      </ReactKeycloakProvider>
    </Content>
  );
};

export default App;
